module.exports = __webpack_public_path__ + "static/media/bugbuster_final.0336c954.pdf";